import React, { useEffect, useState, useAtom } from 'react';
import { Form, Modal, Space,Row,
    Col, Table } from "antd";
import {
    UserOutlined,
    PhoneOutlined,
    MailOutlined,
    CalendarOutlined,
  } from "@ant-design/icons";
import HistorialNotificacionService from "../../../../services/HistorialNotificacionService";
import moment from "moment"


const ModalHistorialNotificacion = ({ documento, visible, setVisible, empresaId }) => {

  const [historialNotificacion, setHistorialNotificacion] = useState(undefined);
  const [nombresCompletos, setNombresCompletos] = useState(undefined);
  useEffect(() => {
    const cargarDatos= async()=>{
        try {
            const historialBuscado= await HistorialNotificacionService.buscarPorDetalleEnvioId(documento?.id , empresaId);
            for (let i = 0; i < historialBuscado.length; i++) {
              historialBuscado[i].fechaHoraNotificacion=moment(historialBuscado[i].fechaHoraNotificacion).format('DD/MM/YYYY hh:mm A');
            }
            setHistorialNotificacion(historialBuscado); 
            console.log("Historial Buscado::", historialBuscado);
            setNombresCompletos(documento?.colaborador?.nombreCompleto);
        } catch (error) {
            console.error(error);
        }

    }
    cargarDatos();
  }, [documento]);

  
    

const columnas = [
    {
      title: "Correo Electrónico",
      dataIndex: "correoElectronico",
    },
    {
      title: "Número de celular",
      dataIndex: "celular",
      render: (text, fila) => {
        if (
          fila.celular === null 
        ) {
          return fila.celular="No Registrado";
        }
        return fila.celular;
      }
    },
    {
      title: "Hora de envío",
      dataIndex: "fechaHoraNotificacion",
    }
  ];

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    
    const onClickBtnCerrar = () => {
        setVisible(false);
    }
  
    return (
        <Modal
            title="Detalle de Notificación"
            visible={visible}
           onOk={onClickBtnCerrar}
           onCancel={onClickBtnCerrar}
            cancelButtonProps={{ style: { display: 'none' } }}
            okText="Aceptar"
            confirmLoading={loading}
            forceRender
            width={1000}
        >
         
        <div style={{ textAlign: "left" }}>
        {<React.Fragment>
          <Space>
            <Row justify="start"><span style={{ fontWeight: "bold" }}>
                <UserOutlined /> Colaborador:
                
                </span></Row>
                <Row justify="start">
                <span>
                  {nombresCompletos}
                </span>
              </Row>
                </Space> 
          


        </React.Fragment>}
      </div>  
      <br/>   
      <div style={{ color: "#000000" }}><Table 
      bordered
      rowKey={(historialNotificacion) => historialNotificacion.id}
      dataSource={historialNotificacion}
      columns={columnas}
      visible={false}
    /></div>
        </Modal>
    );
};

export default ModalHistorialNotificacion;